var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1147,
    height: 1160,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1625,
    y: 656,
    width: 1147,
    height: 1160
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1852,
    y: 1025,
    width: 696,
    height: 425
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1852,
    y: 1025,
    width: 696,
    height: 425
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1852,
    y: 1025,
    width: 696,
    height: 425
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-1625 -656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2431.98 764.544C2431.98 764.544 2870.83 1152.79 2751.15 1534.68 2751.15 1534.68 2626.79 1933.41 1981.31 1781.36 1860.61 1752.92 1754.7 1680.78 1691.58 1578.28 1660.77 1527.76 1639.71 1471.89 1629.53 1413.6 1609.46 1302.86 1674.55 1068.64 1738.64 974.469 1878.31 769.219 2156.56 505.694 2431.98 764.544",
    fill: "#EBF2FC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.277 253.41C166.58 242.762 135.088 202.434 129.311 182.779 116.963 163.182 112.602 131.803 126.082 111.299 131.406 103.086 129.084 95.9492 129.084 84.5644 129.084-28.1504 326.646-28.207 326.646 84.5644 326.646 98.8379 323.418 102.18 331.121 113.451 344.035 132.143 337.408 165.447 326.476 182.836 319.453 203.283 286.432 241.855 288.867 253.467 290.963 311.297 165.107 309.371 165.447 253.467ZM237.324 353.494 244.234 353.494C250.491 353.494 255.562 348.422 255.562 342.166L255.562 323.701C255.562 317.445 250.491 312.373 244.234 312.373L203.113 312.373C196.857 312.373 191.785 317.445 191.785 323.701L191.785 342.109C191.785 348.366 196.857 353.437 203.113 353.437L210.137 353.437 196.656 422.086 250.295 422.086 237.324 353.494ZM0 422.086C5.32422 352.871-8.21289 355.873 49.6738 334.18 78.0592 323.273 105.256 309.495 130.84 293.059L180.57 422.086ZM318.66 287.168C341.953 302.818 367.156 315.42 393.652 324.664 447.744 342.676 447.461 345.168 447.461 422.086L267.344 422.086 318.66 287.168ZM518.205 366.918 523.869 366.918C528.914 366.918 533.014 362.844 533.045 357.799L533.045 343.016C533.014 337.961 528.924 333.871 523.869 333.84L490.678 333.84C485.61 333.809 481.477 337.891 481.445 342.959 481.445 342.978 481.445 342.997 481.445 343.016L481.445 357.799C481.476 362.822 485.541 366.887 490.564 366.918L496.228 366.918 485.41 422.086 528.513 422.086 518.092 366.918ZM460.318 286.488C461.338 277.935 436.019 245.367 431.375 229.848 421.463 214.101 417.951 189.01 428.769 172.414 433.074 165.787 431.205 160.066 431.205 150.891 431.205 60.2656 589.799 60.2656 589.799 150.891 589.799 162.219 587.193 165.051 593.367 174.113 603.732 189.18 598.408 215.914 589.629 229.904 583.965 246.33 557.457 277.312 559.269 286.545 560.969 333.047 459.808 331.517 460.092 286.545ZM583.398 313.676C605.295 326.29 628.552 336.38 652.726 343.752 696.226 358.252 696.056 360.234 695.773 422.086L542.334 422.086 583.398 313.676Z",
    fill: "#2F49BA",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 1.00144 1852 1026.15)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.5d9d626c9602376667285dbc68ae7156.svg";
export { ForwardRef as ReactComponent };